<ui-form-field
  [label]="'تعیین پارتیشن'"
  [inputType]="'number'"
  [isNumericKeyboard]="true"
  [(ngModel)]="partition"
  [hint]="'بین ۱ تا ۲۱'"
>
</ui-form-field>
<div class="d-flex gap-medium">
  <ngx-button
    [destructive]="true"
    (clickHandler)="removePartition()"
    >پاک کردن
  </ngx-button>
  <ngx-button
    [fullWidth]="true"
    [disabled]="+partition() < 1 || +partition() > 22"
    (clickHandler)="updatePartition()"
    >ثبت
  </ngx-button>
</div>
